import { Injectable } from '@angular/core';
import { AppSettings } from '../../_common/constants/app.constants';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { utilityService } from '../../commonservice/utility.service';
import { UserGioLocation } from '../../../models/user/usergioLocation';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Ng2DeviceService } from 'ng2-device-detector';
import { AlertService } from '../../commonservice/alert.service';

declare var sysSettings: any;
declare var ___MobileAgent___: any;

@Injectable()
export class geolocation {
  private userGioLocationData = new ReplaySubject<UserGioLocation>(1);
  userGioLocation: UserGioLocation;
  static islocallowed: boolean = false;
  countrycollection: any;
  static _self: any;

  constructor(private deviceService: Ng2DeviceService, private utilityServ: utilityService, public modal: Modal, private alertService: AlertService) {
    geolocation._self = this;
    this.userGioLocation = new UserGioLocation();
  }

  setserGioLocation(dataValues: UserGioLocation) {
    if (dataValues.latitude != undefined) {
      this.userGioLocationData.next(dataValues);
    }
  }
  getserGioLocation() {
    //return this.userGioLocationData.asObservable();
    return this.getGioLocation();
  }
  getGioLocation() {

    return Observable.create(observer => {
      var options = {
        enableHighAccuracy: true,
        timeout: 500000,
        maximumAge: 50000
      };

      this.userGioLocation = new UserGioLocation();
      const sucessFn = function (position) {

        geolocation._self.userGioLocation.latitude = position.coords.latitude;
        geolocation._self.userGioLocation.longitude = position.coords.longitude;

        // vishu need to comment on prod enviornment
        // geolocation._self.userGioLocation.latitude = 41.6651047;
        // geolocation._self.userGioLocation.longitude = -85.9525486;

        // geolocation._self.userGioLocation.latitude = 41.6998278;//19.0437227; //
        // geolocation._self.userGioLocation.longitude = -85.9631531;//98.1984744; //

        // if ((sysSettings.env = 'DEV')) {
        // geolocation._self.userGioLocation.latitude = 41.6908605;
        // geolocation._self.userGioLocation.longitude = -85.97;
        // }

        geolocation._self.setserGioLocation(geolocation._self.userGioLocation);
        geolocation._self.getCountryFromGioLocation();
        observer.next(geolocation._self.userGioLocation);
        observer.complete();
      };

      const failFn = function (error) {

        let errorMessage: string = '';
        sessionStorage.curCountryObject = '';
        geolocation._self.userGioLocation.latitude = void(0);
        geolocation._self.userGioLocation.longitude = void(0);
        geolocation._self.userGioLocation.userIP = '';
        switch (error.code) {
          case error.PERMISSION_DENIED:
          case 1:
              errorMessage = 'User denied the request for Geolocation.';
            break;
          case error.POSITION_UNAVAILABLE:
          case 2:
              errorMessage = 'Location information is unavailable.';
            break;
          case error.TIMEOUT:
          case 3:
              errorMessage = 'The request to get user location timed out.';
            break;
          default:
            errorMessage = 'An unknown error occurred.';
            break;
        }
        // console.log(errorMessage);
        alert(errorMessage);
        // geolocation._self.alertService.openErrorAlert('errorMessage', errorMessage);
        observer.next(geolocation._self.userGioLocation);
        observer.complete();
      };
      if (navigator.geolocation) {
        let deviceInfo = this.deviceService.getDeviceInfo();
        // IE only allows one call per script to navigator.geolocation.getCurrentPosition, so we need a workaround
        // currentPositionHasBeenDisplayed == true &&
        if (deviceInfo.browser == 'ie') {
          navigator.geolocation.watchPosition(sucessFn, failFn, options);
        } else {
          ___MobileAgent___.Position.Get(sucessFn, failFn, options);
        }
        // navigator.geolocation.getCurrentPosition(sucessFn, failFn, options);
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    });
  }

  getCountryFromGioLocation() {
    if (sessionStorage.curCountryObject == undefined || sessionStorage.curCountryObject == null || sessionStorage.curCountryObject == '') {
      let CountryObject = {};
      let geoURL: string = AppSettings.ICEMasterService + "/GetReverseGeoCode/" + this.userGioLocation.latitude + ',' + this.userGioLocation.longitude;

      this.utilityServ.restGet(geoURL, false, false).subscribe(data => {
        let countryCode = '';
        if (data.Status == 'OK') {
          countryCode = data.ShortName;
          if (localStorage.CountryCollection != undefined) {
            this.countrycollection = JSON.parse(localStorage.CountryCollection);
            const coll = this.countrycollection.filter(function (country) {
              return country.CountryCode === countryCode;
            });
            if (coll.length > 0) {
              CountryObject = coll[0];
              sessionStorage.curCountryObject = JSON.stringify(CountryObject);
            } else {
              sessionStorage.curCountryObject = JSON.stringify(CountryObject);
            }
          }
        }
        else {
          // console.log(data.Status)
        }
      },
        error => {
          console.log('getting error from geo code api from middleware');
        }
      );
    }
  }
  // getCountryFromGioLocation() {
  //   if (sessionStorage.curCountryObject == undefined || sessionStorage.curCountryObject == null || sessionStorage.curCountryObject == '') {
  //     let CountryObject = {};
  //     let geoURL: string = AppSettings.mapgeocodeurl + this.userGioLocation.latitude + ',' + this.userGioLocation.longitude;
  //     this.utilityServ.restGet(geoURL, false).subscribe(data => {
  //       let countryCode = '';
  //       if (data.status == 'OK') {
  //         let countrytmpObj = data.results[0].address_components.filter(function(item) {
  //           return item.types[0] == 'country';
  //         });

  //         if (countrytmpObj.length > 0) {
  //           countryCode = countrytmpObj[0].short_name;
  //         }

  //         if (localStorage.CountryCollection != undefined) {
  //           this.countrycollection = JSON.parse(localStorage.CountryCollection);
  //           const coll = this.countrycollection.filter(function(country) {
  //             return country.CountryCode === countryCode;
  //           });
  //           if (coll.length > 0) {
  //             CountryObject = coll[0];
  //             sessionStorage.curCountryObject = JSON.stringify(CountryObject);
  //           } else {
  //             sessionStorage.curCountryObject = JSON.stringify(CountryObject);
  //           }
  //         }
  //       }
  //     });
  //   }
  // }

  CheckServiceArea() {
    this.userGioLocation = new UserGioLocation();

    this.utilityServ.busy = this.getGioLocation().subscribe(data => {
      this.userGioLocation = data;
      let request = `{"EndUserLongitude": "${this.userGioLocation.longitude}", "EndUserIP": "${sessionStorage.EndUserIP}", "LanguageCode": "${sessionStorage.langCode}", "Session": {"T2": "${sessionStorage.T2}"}, "EndUserLatitude": "${this.userGioLocation.latitude}"}`;
      this.utilityServ.restPost(request, AppSettings.AgentManagementService + '/CheckServiceArea').subscribe(data => {
        if (data == undefined) {
          return;
        }
        if (data.StatusCode == '10000') {
          this.userGioLocation.IsOrigin = true;
        } else {
          this.userGioLocation.IsOrigin = false;
        }
      });
    });
  }

  islocPermissionable() {
    return Observable.create(observer => {
      this.userGioLocation = new UserGioLocation();

      this.utilityServ.busy = this.getGioLocation().subscribe(dataLocation => {
        this.userGioLocation = dataLocation;
        let enevelopGetMyIP = `{ "LanguageCode":"${sessionStorage.langCode}"}`;
        this.utilityServ.restPost(enevelopGetMyIP, AppSettings.GetMyIPService).subscribe(results => {
          if (results.StatusCode == 20001) {
            observer.next(undefined);
            observer.complete();
          }
          if (results.StatusCode == 10000) {
            sessionStorage.EndUserIP = results.IP;

            // vishu need to comment on prod enviornment
            // sessionStorage.EndUserIP = '50.203.151.186';

            // if ((sysSettings.env = 'DEV')) {
            //   sessionStorage.EndUserIP = '50.203.151.186';
            // }

            let request = `{"EndUserLongitude": "${this.userGioLocation.longitude}", "EndUserIP": "${sessionStorage.EndUserIP}",
            "LanguageCode": "${sessionStorage.langCode}", "Session": {"T2": "${sessionStorage.T2}"}, "EndUserLatitude": "${this.userGioLocation.latitude}"}`;
            this.utilityServ.restPost(request, AppSettings.AgentManagementService + '/CheckServiceArea').subscribe(dataCheckService => {
              if (dataCheckService.StatusCode == 20001) {
                observer.next(undefined);
                observer.complete();
              }
              if (dataCheckService.StatusCode == 10000) {
                observer.next(true);
                observer.complete();
              } else {
                sessionStorage.EndUserIP = '';
                observer.next(false);
                observer.complete();
              }
            });
          } else {
            sessionStorage.EndUserIP = '';
            observer.next(false);
            observer.complete();
          }
        });
      });
    });
  }

  getCountryObject() {
    let CountryObject: any = {};
    if (sessionStorage.curCountryObject != undefined && sessionStorage.curCountryObject != null && sessionStorage.curCountryObject != '') {
      CountryObject = JSON.parse(sessionStorage.curCountryObject);
    }

    return CountryObject;
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/geolocation/geoloc.ts